import React from 'react';
import { NavLink, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const Navigation: React.FC = () => {
  const { t } = useTranslation();
  const { lang } = useParams<{ lang: string }>();

  const navItems = [
    { key: '', label: t('navigation.about') },
    { key: 'resume', label: t('navigation.resume') },
    { key: 'portfolio', label: t('navigation.portfolio') },
    { key: 'blog', label: t('navigation.blog') },
    { key: 'contact', label: t('navigation.contact') },
    { key: 'consultation', label: t('navigation.consultation') },
  ];

  return (
    <nav className="bg-gray-800 border border-gray-700 rounded-2xl p-4 mb-8">
      <ul className="flex flex-wrap gap-2 lg:gap-4">
        {navItems.map((item) => (
          <li key={item.key}>
            <NavLink
              to={`/${lang}${item.key ? `/${item.key}` : ''}`}
              className={({ isActive }) =>
                `px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 ${
                  isActive
                    ? 'bg-primary-500 text-white shadow-lg shadow-primary-500/25'
                    : 'text-gray-300 hover:text-white hover:bg-gray-700'
                }`
              }
              end={item.key === ''}
            >
              {item.label}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default Navigation;